import { cssJoin } from '@volvo-cars/css/utils';

import styles from './H4.module.css';

export type H4Types = 'h4' | 'h3';

const H4: React.FC<{
  as?: H4Types;
  children: React.ReactNode;
}> = ({ as = 'h4', children }) => {
  const className = cssJoin('font-20 font-medium', styles.wrapper);

  if (as === 'h3') {
    return <h3 className={className}>{children}</h3>;
  }

  return <h4 className={className}>{children}</h4>;
};

export default H4;
